module.exports = __webpack_public_path__ + "static/media/invisible.629cbd8d.svg";